export const isValidUrl = (url) => {
  try {
    if (/^www\./i.test(url)) {
      url = `https://${url}`;
    }

    const newUrl = new URL(url);
    return /^https?:\/\//.test(newUrl.href);
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const isValidEmail = (email) => {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const checkPasswordStrength = (password) => {
  if (!password) return "";

  let strength = 0;
  if (password.length >= 8) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/\d/.test(password)) strength++;
  if (/[\W_]/.test(password)) strength++;

  if (strength <= 2) return "Weak";
  if (strength === 3 || strength === 4) return "Medium";
  return "Strong";
};

export const alphabetChecker = (value) => {
  return value.replace(/[^a-zA-Z\s]/g, "");
};
